<template>
  <div>
    <a-modal
      v-model="open"
      title="Juega y recibe premios"
      :footer="null"
      class="ruleta"
    >
      <div class="container">
        <audio ref="audioPlayer" :src="rouletteSound"></audio>
        <div class="roulette-wrapper">
          <div class="indicator"></div>

          <div
            class="roulette"
            :style="{ transform: 'rotate(' + angle + 'deg)' }"
          >
            <div
              class="segment casino-button1"
              v-for="(segment, index) in segments"
              :key="index"
              :style="getSegmentStyle(index)"
            >
              <div>
                <div class="content" :style="getContentStyle(segment.label)">
                  <div :style="getContentTextStyle()">
                    {{ segment.label }}
                  </div>
                </div>
                <div
                  v-if="segment.image"
                  class="content-image"
                  :style="getContentImageStyle()"
                >
                  <img
                    :src="segment.image"
                    alt="premio"
                    class="segment-image"
                    :style="getImageStyle()"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          @click="spin"
          :disabled="isSpinning"
          class="spin"
          data-text="¡Girar!"
        >
          <!-- <span
            style="
              font-weight: 700;
              z-index: 10;
              position: absolute;
              width: 60px;
            "
          >
            <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              <path
                id="circlePath"
                d="M 15, 65 a 40,40 0 1,1 80,0 40,40 0 1,1 -80,0"
                fill="transparent"
              />
              <text>
                <textPath href="#circlePath" fill="white" font-size="1.3rem">
                  Click!
                </textPath>
              </text>
            </svg>
          </span> -->
          <img
            :src="tapToSpinRoulette"
            alt="premio"
            class="tap-to-spin-image"
          />

          <div class="inside"></div>

          <img :src="spinHand" alt="Click Here" class="spin-hand" />
        </button>
        <div class="points">
          <div class="point"></div>
          <div class="point"></div>
          <div class="point"></div>
          <div class="point"></div>
          <div class="point"></div>
          <div class="point"></div>
          <div class="point"></div>
          <div class="point"></div>
        </div>
      </div>
      <div v-if="winner" class="winner">
        <!-- 🎉 ¡Felicidades! 🎉 -->
        <!-- <br /> -->

        <div style="position: relative">
          <img :src="bannerRoulette" alt="premio" class="banner-image" />
          <span class="winner-amount">
            <svg width="100%" height="50" xmlns="http://www.w3.org/2000/svg">
              <!-- Definir el gradiente de oro -->
              <defs>
                <linearGradient
                  id="gold-gradient"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="100%"
                >
                  <stop
                    offset="0%"
                    style="stop-color: #ffd700; stop-opacity: 1"
                  />
                  <stop
                    offset="50%"
                    style="stop-color: #ffec8b; stop-opacity: 1"
                  />
                  <stop
                    offset="100%"
                    style="stop-color: #ffa500; stop-opacity: 1"
                  />
                </linearGradient>

                <!-- Definir un filtro para dar volumen -->
                <filter id="volumen" x="0" y="0">
                  <feGaussianBlur
                    in="SourceAlpha"
                    stdDeviation="2"
                    result="blur"
                  />
                  <feOffset in="blur" dx="2" dy="2" result="offsetBlur" />
                  <feMerge>
                    <feMergeNode in="offsetBlur" />
                    <feMergeNode in="SourceGraphic" />
                  </feMerge>
                </filter>
              </defs>

              <!-- Aplicar el texto con el filtro de volumen y el gradiente de oro -->
              <text
                x="50%"
                y="70%"
                font-family="Arial"
                font-size="28"
                fill="url(#gold-gradient)"
                filter="url(#volumen)"
                text-anchor="middle"
                dominant-baseline="middle"
              >
                {{ winner.label }}
              </text>
            </svg>
          </span>
        </div>

        <div class="buttons-roulette">
          <a-button type="ghost" class="cancel" @click="handleCancel">{{
            labels.home.roulette.cancel
          }}</a-button>
          <a-button type="ghost" class="claim" @click="handleClaim">{{
            labels.home.roulette.claim
          }}</a-button>
        </div>
      </div>
      <Confetti v-if="winner" style="position: absolute" />
      <audio ref="audioPlayerConfetti" :src="confettiSound"></audio>
    </a-modal>

    <a-modal
      :title="labels.home.roulette.important"
      :visible="visible"
      :confirm-loading="confirmLoading"
      :footer="null"
      :closable="true"
      @cancel="visible = false"
      centered
      class="confirm-modal"
    >
      <h2>{{ labels.home.roulette.conditionClaimText }}</h2>
      <div class="content-buttons">
        <a-button
          type="ghost"
          class="login"
          @click="$router.push({ name: 'login' })"
          >{{ labels.home.roulette.login }}</a-button
        >
        <a-button
          type="ghost"
          class="register"
          @click="$router.push({ name: 'register' })"
          >{{ labels.home.roulette.register }}</a-button
        >
        <a-button type="ghost" class="cancel" @click="handleCancel">{{
          labels.home.roulette.cancel
        }}</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import tetherLogo from "@/assets/images/tether-usdt.png";
import bannerRoulette from "@/assets/images/banner-roulette.webp";
import tapToSpinRoulette from "@/assets/images/tap-to-spin-roulette.png";
import spinHand from "@/assets/images/spin-hand.webp";
import rouletteSound from "@/assets/sounds/rouletteSound.mp3";
import confettiSound from "@/assets/sounds/confettiSound.mp3";
import Confetti from "@/components/Confetti.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import labels from "@/utils/labels";
import { getCookie, saveCookie, rouletteCookieName } from "@/utils/utils";
export default {
  components: {
    Confetti,
  },
  data() {
    return {
      modalText: "Content of the modal",
      visible: false,
      confirmLoading: false,

      tetherLogo,
      spinHand,
      bannerRoulette,
      tapToSpinRoulette,
      rouletteSound,
      confettiSound,
      labels,
      winnerName: null, // Poner el name de un premio para definir previamente el ganador. null para seleccionar al azar
      open: false,
      // El total de premios debe ser entre 8 y 18
      segments: [
        {
          name: "1",
          type: "BONO",
          label: "Bono 1",
          image: null,
          colors: ["#FF6F61", "#C0392B", "#E57373"],
          prize: "KUWVG20",
        },
        {
          name: "2",
          type: "BONO",
          label: "Bono 2",
          image: null,
          colors: ["#B038DC", "#640A99", "#8034AE"],
          prize: "WIDDT15",
        },
        {
          name: "3",
          type: "BONO",
          label: "Bono 3",
          image: null,
          colors: ["#A8E6CF", "#66BB6A", "#1E8449"],
          prize: "2SPMT50",
        },
        {
          name: "4",
          type: "BONO",
          label: "Bono 4",
          image: null,
          colors: ["#FF6F61", "#C22D28", "#E60408"],
          prize: "XR4N05",
        },
        {
          name: "5",
          type: "BONO",
          label: "Bono 5",
          image: null,
          colors: ["#B39DDB", "#6A1B9A", "#8E44AD"],
          prize: "2SPMT30",
        },
      ],
      angle: 0,
      isSpinning: false,
      winner: null,
    };
  },
  computed: {
    ...mapState("clientAuth", ["user"]),
    ...mapGetters("systemConfig", ["getRouletteStatus"]),
  },
  methods: {
    ...mapActions("systemConfig", ["fetchRouletteStatusConfig"]),
    deletePlayOfCookie(name) {
      const expirationDate = new Date();
      expirationDate.setFullYear(expirationDate.getFullYear() - 1);
      const cookieValue = `${name}=; expires=${expirationDate.toUTCString()}; path=/`;
      document.cookie = cookieValue;
    },
    spin() {
      if (this.isSpinning) return;

      this.isSpinning = true;
      if (this.$refs.audioPlayer.paused) {
        this.$refs.audioPlayer.currentTime = 0;
        this.$refs.audioPlayer.volume = 0.4;
        this.$refs.audioPlayer.currentTime = 3.25;
        this.$refs.audioPlayer.play();
      }
      this.winner = null;

      const numRandom = Math.random();
      const randomSpin = Math.floor(numRandom * 360) + 360 * 6;
      let finalAngle = this.angle + randomSpin;

      let angleSize = 360 / this.segments.length;
      let centreAngle = Math.trunc(finalAngle / angleSize);
      finalAngle = centreAngle * angleSize + angleSize / 2;

      if (this.winnerName) {
        let winnerIndex = this.segments.findIndex(
          (element) => element.name === this.winnerName
        );
        let anglePerSegment = 360 / this.segments.length;
        let targetAngle = winnerIndex * anglePerSegment;
        const completeTurns = 360 * 6;

        let anguloActual =
          Math.trunc(this.angle / 360) * 360 + 360 / this.segments.length / 2;

        finalAngle =
          completeTurns + anguloActual - targetAngle - anglePerSegment;

        this.angle = finalAngle;
      } else {
        this.angle = finalAngle;
      }

      // Después de 5 segundos (duración del giro), determina el premio
      setTimeout(() => {
        this.isSpinning = false;
        this.$refs.audioPlayer.pause();
        this.determineWinner(finalAngle);
      }, 5000);
    },
    getSegmentStyle(index) {
      const totalSegments = this.segments.length;
      const anglePerSegment = 360 / totalSegments;
      const rotation = anglePerSegment * index;

      let boxShadow =
        "0 1rem 1.25rem 0 rgba(22,75,195,0.50) inset, 0 -0.25rem 1.5rem 0 rgba(110, 15, 155, 1) inset, 0 0.75rem 0.5rem rgba(255,255,255, 0.4) inset, 0 0.25rem 0.5rem 0 rgba(180, 70, 207, 1) inset";

      return {
        transform: `rotate(${rotation}deg) skewY(-${90 - anglePerSegment}deg)`,
        /* background: `linear-gradient(45deg, ${this.segments[index].colors[0]}, ${this.segments[index].colors[1]}, ${this.segments[index].colors[2]})`, */
        background: `linear-gradient(-45deg, ${this.segments[index].colors[0]} 0%, ${this.segments[index].colors[1]} 100%)`,
        boxShadow: boxShadow,
      };
    },
    getContentStyle(label) {
      const totalSegments = this.segments.length;
      const anglePerSegment = 360 / totalSegments;

      let left = "0";
      if (label.length >= 5) {
        left = "-6px";
      } else if ((label + "").length >= 4) {
        left = "-1px";
      } else if ((label + "").length >= 3) {
        left = "2px";
      } else if ((label + "").length >= 2) {
        left = "5px";
      } else if ((label + "").length >= 1) {
        left = "8px";
      }

      return {
        transform: `rotate(0deg) skewY(${90 - anglePerSegment}deg) !important`,
        transformOrigin: "center center",
        top: "50%",
        left: left,
      };
    },
    getContentTextStyle() {
      let left = "3px";
      let right = "0";
      let rotate = `rotate(-80deg)`;
      if (this.segments.length >= 5 && this.segments.length < 8) {
        left = "40px";
        right = "18px";
        rotate = `rotate(-55deg)`;
      } else if (this.segments.length == 8) {
        left = "18px";
        right = "10px";
        rotate = `rotate(-75deg)`;
      } else if (this.segments.length <= 10) {
        left = "12px";
        right = "10px";
        rotate = `rotate(-75deg)`;
      } else if (this.segments.length <= 12) {
        left = "10px";
        right = "8px";
        rotate = `rotate(-80deg)`;
      } else if (this.segments.length <= 14) {
        left = "7px";
        right = "6px";
        rotate = `rotate(-80deg)`;
      }
      return {
        transform: rotate,
        marginLeft: left,
        marginRight: right,
      };
    },
    getContentImageStyle() {
      const totalSegments = this.segments.length;
      const anglePerSegment = 360 / totalSegments;

      let transform = `rotate(0deg) skewY(${
        90 - anglePerSegment
      }deg) !important`;
      let left = `${anglePerSegment / 2 - 8}px`;
      let bottom = "20%";

      return {
        transform: transform,
        left: left,
        bottom: bottom,
      };
    },
    getImageStyle() {
      let transform = `rotate(-85deg)`;

      if (this.segments.length >= 5 && this.segments.length < 8) {
        transform = `rotate(300deg)`;
      }

      return {
        transform: transform,
      };
    },
    determineWinner(finalAngle) {
      let normalizedAngle = finalAngle % 360;

      // Calcular el ángulo por segmento
      const anglePerSegment = 360 / this.segments.length;

      const winningIndex =
        Math.floor((360 - normalizedAngle) / anglePerSegment) %
        this.segments.length;

      this.winner = this.segments[winningIndex];

      let winnerCookie = getCookie(rouletteCookieName);
      if (!winnerCookie) {
        saveCookie(
          rouletteCookieName,
          JSON.stringify(this.winner),
          30 * 24 * 60 * 60 * 1000
        ); // 30 dias
      }

      if (
        this.$refs.audioPlayerConfetti &&
        this.$refs.audioPlayerConfetti.paused
      ) {
        this.$refs.audioPlayerConfetti.currentTime = 0;
        //this.$refs.audioPlayerConfetti.volume = 0.4;
        //this.$refs.audioPlayerConfetti.currentTime = 3.25;
        this.$refs.audioPlayerConfetti.play();
      }
    },
    handleClaim() {
      // TO DO: Registrar y reclamar recompensa, lo cual se debe tratar en el backend
      this.open = false;
      localStorage.setItem("rp", 1);

      this.visible = true;
    },
    handleCancel() {
      this.open = false;
      localStorage.setItem("rp", 1);
      this.visible = false;
    },
    async initRoulette() {
      try {
        const { data: value } = await this.fetchRouletteStatusConfig();

        if (value) {
          const roulettePlayed = localStorage.getItem("rp");
          if ((!roulettePlayed || roulettePlayed === "0") && !this.user) {
            this.open = true;
            localStorage.setItem("rp", 1);
          }
        }
      } catch (error) {
        console.error(error);
        this.open = false;
      }
    },
  },
  mounted() {
    this.initRoulette();

    let angleSize = 360 / this.segments.length;
    this.angle = angleSize / 2;
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/variable";
.ruleta,
.confirm-modal {
  overflow: hidden;
  .ant-modal {
    overflow: hidden;

    .ant-modal-content {
      background: var(--modal-bg) !important;
      color: var(--text) !important;

      h2 {
        color: var(--text) !important;
        text-align: center;
        margin-bottom: 20px;
      }

      .ant-modal-header {
        background: var(--modal-bg) !important;

        .ant-modal-title {
          color: var(--text) !important;
        }
      }

      .ant-modal-close {
        color: var(--text);
      }

      .ant-modal-body {
        background-color: var(--modal-bg) !important;
      }

      .content-buttons {
        display: flex;
        justify-content: center;
        gap: 10px;

        .login,
        .register {
          color: #33ffad;
          border-color: #33ffad;

          &:hover {
            color: white;
            border-color: white;
          }
        }
      }
    }

    .container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-top: 40px;
      padding-bottom: 40px;
      position: relative;
    }

    .roulette-wrapper {
      width: 300px;
      height: 300px;
      position: relative;
      border-radius: 50%;
      overflow: hidden;
      border: 5px solid #3b8900c7;
      -webkit-box-shadow: 0px 0px 120px -45px rgba(18, 255, 101, 1);
      -moz-box-shadow: 0px 0px 120px -45px rgba(18, 255, 101, 1);
      box-shadow: 0px 0px 120px -45px rgba(18, 255, 101, 1);
    }

    .roulette {
      width: 100%;
      height: 100%;
      position: absolute;
      transition: transform 5s ease-out;
      transform-origin: center;
      overflow: visible;
    }

    .segment {
      width: 50%;
      height: 50%;
      position: absolute;
      top: 0;
      left: 50%;
      transform-origin: 0% 100%;
      overflow: hidden;
    }

    .content {
      position: absolute;
      font-size: 15px;
      font-weight: bold;
      color: var(--text);
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
    }

    .content-image {
      position: absolute;

      display: flex;
      justify-content: center;
      align-items: center;

      .segment-image {
        width: 20px;
        height: 20px;
        object-fit: cover;
      }
    }

    .points {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 100%;
      height: 100%;
      z-index: 0;
      .point {
        position: absolute;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: var(--text) !important;
        margin-top: -5px;
        margin-left: -5px;
        animation: parpadeo 2s infinite;
        z-index: 1;
      }

      /* Posicionamos los puntos en el círculo */
      .point:nth-child(1) {
        transform: rotate(0deg) translateX(150px);
        animation-delay: 0s;
      }
      .point:nth-child(2) {
        transform: rotate(45deg) translateX(150px);
        animation-delay: 0.2s;
      }
      .point:nth-child(3) {
        transform: rotate(90deg) translateX(150px);
        animation-delay: 0.4s;
      }
      .point:nth-child(4) {
        transform: rotate(135deg) translateX(150px);
        animation-delay: 0.6s;
      }
      .point:nth-child(5) {
        transform: rotate(180deg) translateX(150px);
        animation-delay: 0.8s;
      }
      .point:nth-child(6) {
        transform: rotate(225deg) translateX(150px);
        animation-delay: 1s;
      }
      .point:nth-child(7) {
        transform: rotate(270deg) translateX(150px);
        animation-delay: 1.2s;
      }
      .point:nth-child(8) {
        transform: rotate(315deg) translateX(150px);
        animation-delay: 1.4s;
      }
    }

    button {
      &.spin {
        font-size: 18px;
        cursor: pointer;
        color: var(--text);
        border: none;
        border-radius: 100%;
        width: 90px;
        height: 90px;
        position: absolute;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        /* margin-top: -5px; */
        background: green;
        background: linear-gradient(to right, #ff700a, #ff9800);
        transition: transform 0.1s ease, background-color 0.2s ease;
        filter: brightness(1);
        z-index: 10;

        &:active {
          transform: scale(0.9);
        }

        .inside {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 70%;
          height: 70%;
          background: linear-gradient(to left, #ff700a, #ff9800);
          border-radius: 100%;
        }

        .spin-hand {
          position: absolute;
          width: 90px;
          left: 30%;
          top: 60%;
          animation: pulse 2s infinite;
        }

        .tap-to-spin-image {
          position: absolute;
          width: 80px;
          top: 10%;
          animation: float 3s ease-in-out infinite;
        }
      }
    }

    button:disabled {
      background-color: var(--text-muted);
    }

    .winner {
      font-size: 24px;
      color: var(--text);
      text-align: center;
      position: relative;

      .banner-image {
        width: 80%;
      }

      .winner-amount {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateY(-50%) translateX(-50%);
      }

      .buttons-roulette {
        display: flex;
        gap: 10px;
        justify-content: center;
        margin-top: 20px;

        .cancel {
          &:hover {
            color: #33ffad;
            border-color: #33ffad;
          }
        }

        .claim {
          color: #33ffad;
          border-color: #33ffad;

          &:hover {
            color: white;
            border-color: white;
          }
        }
      }
    }

    /* Indicador */
    .indicator {
      width: 0;
      height: 0;
      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 110px solid rgba(54, 113, 3, 0.7);
      position: absolute;
      top: -20px;
      left: 50%;
      transform: translateX(-50%) rotate(180deg);
      z-index: 10;
    }

    .indicator::before {
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 75px solid rgba(77, 255, 0, 0.6);
      position: absolute;
      top: 16px;
      left: 50%;
      z-index: 9;
      transform: translateX(-50%);
      content: "";
      filter: drop-shadow(6px 2px 4px rgba(0, 0, 0, 0.8));
    }

    .casino-button {
      background: linear-gradient(45deg, #ff4d4d, #ffcc00);
      transition: all 0.3s ease;
      border: none;
      cursor: pointer;
    }
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

@keyframes float {
  0% {
    transform: rotate(5deg);
  }
  50% {
    transform: rotate(-5deg);
  }
  100% {
    transform: rotate(5deg);
  }
}

/* Animación de parpadeo */
@keyframes parpadeo {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

.light {
  .ruleta,
  .confirm-modal {
    .ant-modal {
      .ant-modal-content {
        .content-buttons {
          display: flex;
          justify-content: center;
          gap: 10px;

          .login,
          .register {
            color: white;
            border-color: var(--btn-bg-primary);
            background-color: var(--btn-bg-primary) !important;

            &:hover {
              color: var(--btn-bg-primary);
              border-color: var(--btn-bg-primary);
              background-color: white !important;
            }
          }

          .cancel {
            color: var(--btn-bg-primary);
            border-color: var(--btn-bg-primary);
            background-color: white;

            &:hover {
              color: white;
              border-color: var(--btn-bg-primary);
              background-color: var(--btn-bg-primary) !important;
            }
          }
        }

        .winner {
          .buttons-roulette {
            .cancel {
              color: var(--btn-bg-primary);
              border-color: var(--btn-bg-primary);
              background-color: white;

              &:hover {
                color: white;
                border-color: var(--btn-bg-primary);
                background-color: var(--btn-bg-primary) !important;
              }
            }

            .claim {
              color: white;
              border-color: var(--btn-bg-primary);
              background-color: var(--btn-bg-primary) !important;

              &:hover {
                color: var(--btn-bg-primary);
                border-color: var(--btn-bg-primary);
                background-color: white !important;
              }
            }
          }
        }
      }
    }
  }
}
</style>
